export default {"src":"/_next/static/media/uploadIcon.279020d1.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};